<template>
  <div class="project-material">

    <h3 class="title">采购记录</h3>

    <el-table :data="purchaseListData.applys" style="width: 100%" v-loading="purchaseLoading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="采购申请编号">
      </el-table-column>
      <el-table-column prop="name" label="采购项目">
      </el-table-column>

      <el-table-column prop="department.name" label="申请部门">
      </el-table-column>

      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row, '70')" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>


    <h3 class="title" style="margin-top:25px;">采购备案</h3>
    <el-table :data="purchaseListData.records" style="width: 100%" v-loading="purchaseLoading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="采购申请编号">
      </el-table-column>
      <el-table-column prop="name" label="采购项目">
      </el-table-column>

      <el-table-column prop="department.name" label="申请部门">
      </el-table-column>

      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row, '71')" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <project-info></project-info>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import ApprovalStatus from '@/components/ApprovalStatus'
  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
    },
    mixins: [approvalType, Role],
    props: ['projectId'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 是否可切换公司
        noSelectOrganization: false,
        houseList: "",

        organizationListData: [],
        depId: '',
        addMeetingRoomStatus: false,

        form: {
          houseId: '',
          type: 0
        },
        // 列表
        purchaseLoading: true,
        purchaseListData: [],
        // useLoading: true,
        // backLoading: true,
        // useListData: [],
        // backListData: [],

        // filter
        filterKey: "",
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      // 获取采购列表
      this.getLists()
    },
    mounted() {
      if (this.depId == "7") {
        this.noSelectOrganization = false
        this.depId = ""
      }
    },
    methods: {
      // 显示审批表详情
      projectDetail(row, type) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.id,
          // 强行吧tableType变成50 也就是采购材料
          tableType: type,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      getDateByTime(time) {
        // return time
        return window.util.getFormatDate(time, true)
      },
      // 获取列表
      getLists() {
        this.purchaseLoading = true
        ajax.get('/purchase/relate/list/' + this.projectId, '', (res) => {
          this.purchaseLoading = false
          this.purchaseListData = res.vo
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/project/purchase.vue